import styled from "@emotion/styled"

const ArticleAsideTabsWrapper = styled.div`
  background: #f8f8f8;

  ${({ theme }) => theme.breakpoints.down("lg")} {
    border-radius: 15px;
    padding: 15px 10px 20px 10px;
    margin-bottom: 20px;
  }

  ${({ theme }) => theme.breakpoints.between("lg", "xl")} {
    border-radius: 15px;
    padding: 15px 10px 20px 10px;
    margin-bottom: 26px;
  }

  ${({ theme }) => theme.breakpoints.between("xl", "2xl")} {
    border-radius: 15px;
    padding: 15px 10px 20px 10px;
    margin-bottom: 32px;
  }

  ${({ theme }) => theme.breakpoints.up("2xl")} {
    border-radius: 15px;
    padding: 15px 10px 20px 10px;
    margin-bottom: 40px;
  }
`

export default ArticleAsideTabsWrapper
